let store
let persistor

const setGlobalReduxStore = (reduxRef: any, persistorRef: any) => {
  // eslint-disable-next-line no-unused-expressions
  (store = reduxRef), (persistor = persistorRef)
}

export { persistor, store, setGlobalReduxStore }
